"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var ShopContext_1 = require("./ShopContext");
var hooks_1 = require("preact/hooks");
var ShopDescription = function () {
    var _a = (0, hooks_1.useContext)(ShopContext_1.default), options = _a.options, optionIndex = _a.optionIndex;
    return (0, preact_1.h)("div", { class: "shop-v2__description" }, options[optionIndex].description.value);
};
exports.default = ShopDescription;
